/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagePostImageFrombase64 } from "../../funcs/imagePostImageFrombase64.js";
import { PostImageFrombase64Request$zodSchema } from "../../models/postimagefrombase64op.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostImageFrombase64Request$zodSchema,
};

export const tool$imagePostImageFrombase64: ToolDefinition<typeof args> = {
  name: "image-post-image-frombase64",
  description: `通过Base64编码上传图片

当你需要在前端处理完图片（比如裁剪、加滤镜后），不通过传统表单，而是直接上传图片的场景，这个接口就派上用场了。

## 功能概述
你只需要将图片的 Base64 编码字符串发送过来，我们就会把它解码、保存为图片文件，并返回一个可供访问的公开 URL。

## 使用须知

> [!IMPORTANT]
> **关于 \`imageData\` 格式**
> 你发送的 \`imageData\` 字符串必须是完整的 Base64 Data URI 格式，它需要包含 MIME 类型信息，例如 \`data:image/png;base64,iVBORw0KGgo...\`。缺少 \`data:image/...;base64,\` 前缀将导致解码失败。`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imagePostImageFrombase64(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
